"use client";

import styles from "./selector-component.module.css";

export default function SelectorComponentListItem({
  text,
  icon,
  isActive,
  onClick,
}: {
  text: string;
  icon?: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
}) {
  return (
    <li
      className={`${styles.selectorListItem} ${isActive ? styles.isActiveItem : ""}`}
      role="option"
      aria-selected={isActive}
    >
      <button
        type="button"
        className={styles.itemButton}
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
      >
        {icon && <span className={styles.itemIcon}>{icon}</span>}
        <span className={styles.itemText}>{text}</span>
      </button>
    </li>
  );
}
